import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import ApplyKnow from '../components/ApplyKnow'
import Job from '../components/Job'
import JobDetail from '../components/JobDetail'
import JobEdit from '../components/JobEdit'
import Login from '../components/Login'
import Register from '../components/Register'
import ResetPassword from '../components/ResetPassword'
import PreviewFile from '../components/PreviewFile'
import JobNewMore from '../components/JobNewMore'
import ForgetPassword from '../components/ForgetPassword.vue'
Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/job',
            name: 'Job',
            component: Job
        },
        {
            path: '/ApplyKnow',
            name: 'ApplyKnow',
            component: ApplyKnow
        },
        {
            path: '/jobDetail',
            name: 'JobDetail',
            component: JobDetail
        },
        {
            path: '/JobEdit',
            name: 'JobEdit',
            component: JobEdit
        },
        {
            path: '/Login',
            name: 'Login',
            component: Login
        },
        {
            path: '/Register',
            name: 'Register',
            component: Register
        },
        {
            path: '/ResetPassword',
            name: 'ResetPassword',
            component: ResetPassword
        },
        {
            path: '/PreviewFile',
            name: 'PreviewFile',
            component: PreviewFile
        },
        {
            path: '/JobNewMore',
            name: 'JobNewMore',
            component: JobNewMore
        },
        {
            path: '/ForgetPassword',
            name: 'ForgetPassword',
            component: ForgetPassword
        },
    ]
})
